const hasGeometry = (lbu) => {
	return (lbu &&
    lbu.geometry &&
		lbu.geometry.coordinates &&
		lbu.geometry.coordinates.length === 2)
}

export { hasGeometry }
